<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title class="dodo">الإنفوكرافيك</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" persistent max-width="900px">
        <v-btn slot="activator" color="primary" dark class="dodo mb-2" @click="dialog = true">إضافة إنفوكرافيك جديد</v-btn>
        <v-form v-model="valid" ref="form">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      v-model="editedItem.title"
                      :rules="titleRules"
                      class="form_label"
                      label="العنوان"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field label="أضف صور الإنفوكرافيك" @click="pickFiles" prepend-icon="fa-solid fa-paperclip"></v-text-field>
                    <input type="file" multiple style="display:none" ref="images" accept="image/*" @change="onFilesPicked">
                  </v-flex>
                  
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs6 sm4 md3 v-for="(img, idx) in editedItem.images" :key="'existing-'+idx" style="padding:6px; position: relative;">
                        <v-img :src="Url + 'img/infographics/thumb/' + img" height="240"></v-img>
                        <v-btn absolute top right icon small color="red" @click="deleteExistingImage(img, idx)" style="background: rgba(255,255,255,0.7); margin: 2px;">
                            <v-icon small>fas fa-trash</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs6 sm4 md3 v-for="(preview, idx) in previews" :key="'preview-'+idx" style="padding:6px; position: relative;">
                        <v-img :src="preview" height="240"></v-img>
                        <v-btn absolute top right icon small color="error" @click="removeSelected(idx)" style="background: rgba(255,255,255,0.7); margin: 2px;">
                           <v-icon small>fas fa-times</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close" :disabled="saving">Cancel</v-btn>
              <v-btn color="blue darken-1" flat @click="save" :loading="saving" :disabled="saving">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="infographics"
      class="elevation-1"
      :items-per-page="15"
      hide-default-footer
      disable-pagination>

      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">تعديل</v-icon>
        |
        <v-icon small @click="deleteItem(item)">حذف</v-icon>
      </template>
    </v-data-table>

    <v-pagination
      class="pagination"
      total-visible="20"
      v-model="page"
      color="#c7000b"
      style="position: relative; top: 20px;"
      circle=""
      :length="pageCount">
    </v-pagination>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['settings'],
  data() {
    return {
      errors: {},
      page: 1,
      pageCount: 1,
      current_page: 1,
      last_page: 1,
      valid: false,
      dialog: false,
      infographics: [],
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'العنوان', value: 'title', sortable: false },
        { text: 'تاريخ الإضافة', value: 'created_at', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      titleRules: [
        (v) => !!v || 'يجب ادخال عنوان الإنفوكرافيك',
      ],
      editedIndex: -1,
      editedItem: {
        title: '',
        images: []
      },
      defaultItem: {
        title: '',
        images: []
      },
      files: [],
      previews: [],
      saving: false
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'إضافة إنفوكرافيك جديد' : 'تعديل إنفوكرافيك'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    page() {
      this.getMoreitems()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    pickFiles() {
      this.$refs.images.click()
    },
    onFilesPicked(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files || !files.length) return
      this.files = []
      this.previews = []
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        this.files.push(file)
        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.addEventListener('load', () => {
          this.previews.push(fr.result)
        })
      }
    },
    removeSelected(index) {
      this.files.splice(index, 1)
      this.previews.splice(index, 1)
    },
    deleteExistingImage(img, index) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.post('infographics/delete-image', {
            id: this.editedItem.id,
            image: img
          }, {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorizations: "Bearer " + this.$store.state.AdminInfo.token
            }
          }).then(() => {
            this.editedItem.images.splice(index, 1)
            this.$swal.fire('Deleted!', 'Image has been deleted.', 'success')
          }).catch(() => {
             this.$swal.fire('Error!', 'Failed to delete image.', 'error')
          })
        }
      })
    },
    getMoreitems() {
      if (this.current_page <= this.last_page) {
        this.current_page = this.page
        this.initialize()
      }
    },
    initialize() {
      axios.get('infographics', {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorizations: "Bearer " + this.$store.state.AdminInfo.token
        }
      }).then(d => {
        const payload = d.data
        this.infographics = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : [])
        this.last_page = payload.last_page || 1
        this.pageCount = payload.last_page || 1
      })
    },
    editItem(item) {
      this.editedIndex = this.infographics.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.images = Array.isArray(item.images) ? item.images.slice() : []
      this.files = []
      this.previews = []
      this.dialog = true
    },
    deleteItem(item) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.delete('infographics/' + item.id, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Accept: "application/json",
              Authorizations: "Bearer " + this.$store.state.AdminInfo.token
            },
          }).then(() => {
            this.$swal.fire('Successfully', 'done', "success");
            this.initialize()
          }).catch(() => {});
        }
      })
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.files = []
        this.previews = []
      }, 300)
    },
    save() {
      this.saving = true
      const formData = new FormData()
      formData.append('title', this.editedItem.title)
      if (this.files && this.files.length) {
        for (let i = 0; i < this.files.length; i++) {
          formData.append('images[]', this.files[i])
        }
      }
      if (this.editedIndex > -1) {
        axios.post('infographics/' + this.editedItem.id, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
            Authorizations: "Bearer " + this.$store.state.AdminInfo.token
          }
        }).then(() => {
          this.$swal.fire('Successfully', 'done', "success");
          this.dialog = false
          this.initialize()
        }).catch(() => {}).finally(() => { this.saving = false })
      } else {
        axios.post('infographics', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
            Authorizations: "Bearer " + this.$store.state.AdminInfo.token
          }
        }).then(() => {
          this.$swal.fire('Successfully', 'done', "success");
          this.dialog = false
          this.initialize()
        }).catch(() => {}).finally(() => { this.saving = false })
      }
    },
  }
}
</script>
